export enum UserErrors {
  NOT_FOUND_USER = "Not Found user",
}
